export enum TipoCompetenciaCobrancaEnum {
  DoisMesesAntesVencimento = "5B04913A-6C46-4EBE-BFB3-F311EE9E0923",
  MesAnteriorAoVencimento = "5B04913A-6C46-4EBE-BFB3-F311EE9E0924",
  MesDoVencimento = "5B04913A-6C46-4EBE-BFB3-F311EE9E0925",
}

export enum TipoVencimentoCobrancaEnum {
  GerarTodasCobrançasVencimento = "5B04913A-6C46-4EBE-BFB3-F311EE9E0923",
  GerarApenasArrecadaçoesDiaUtil = "5B04913A-6C46-4EBE-BFB3-F311EE9E0924",
  GerarTodasCobrançasDiaUtil = "5B04913A-6C46-4EBE-BFB3-F311EE9E0925",
}

export enum TipoVisualizacaoPagadorCobrancaEnum {
  NomeInquilinoProprietárioPagadorBoletos = "5B04913A-6C46-4EBE-BFB3-F311EE9E0923",
  SomenteNomeProprietarioPagadorBoletos = "5B04913A-6C46-4EBE-BFB3-F311EE9E0924",
  SomenteNomeInquilinoPagadorBoletos = "5B04913A-6C46-4EBE-BFB3-F311EE9E0925",
}

export interface JurosParametroCobranca {
  id?: string;
  diasInadimplencia: number;
  honorario: boolean;
  valor: number;
  juridico?: boolean;
}

export interface ParametroCobrancaRequest {
  diaVencimento: number;
  tipoIndiceMonetarioId: string;
  tipoVencimentoCobrancaId: TipoVencimentoCobrancaEnum;
  tipoCompetenciaCobrancaId: TipoCompetenciaCobrancaEnum;
  proRataDia: boolean;
  gerarBoletoUnicoNormaisExtra: boolean;
  taxaMulta: number;
  diasProcessarAtualizacaoMoneraria: number;
  juros: JurosParametroCobranca[];
  categoriaAcordoId: string;
  categoriaMultaId: string;
  categoriaJurosId: string;
  categoriaCorrecaoMonetariaId: string;
  enviarArrecadacaoEmail: boolean;
  enviarArrecadacaoPush: boolean;
  diasCancelamentoAcordo: number;
  categoriaJurosDespesaId: string;
  categoriaTransferenciaEnvioId: string;
  categoriaTransferenciaRecebimentoId: string;
  categoriaRegistroBoletoId: string;
  categoriaGrupoDescontoId: string;
  categoriaMultaDespesaId: string;
  cobrancaAutomaticaCartao: boolean | null;
  cobrancaAutomaticaCartaoDiasAntesVencimento: number | null;
  formasRecebimentoPadraoArrecadacaoIds: string[];
  protestoAutomaticoBoleto: boolean | null;
  diasParaProtestar: number | null;
  certificadoDigitalArquivoId?: string;
  certificadoDigitalSenha?: string;
}

export interface ParametroCobrancaForm extends Omit<
  ParametroCobrancaRequest,
  "enviarArrecadacaoEmail" | "enviarArrecadacaoPush"
> {
  enviarArrecadacaoEmail: "s" | "n";
  enviarArrecadacaoPush: "s" | "n";
  jurosHonorario: JurosParametroCobranca[];
  jurosMensal: JurosParametroCobranca[];
  certificadoDigitalNome?: string;
  certificadoDigitalExisteSenha?: boolean;
}

export interface ParametroCobrancaResponse extends Omit<
  ParametroCobrancaRequest,
  "certificadoDigitalArquivoId" | "certificadoDigitalSenha"
> {
  id: string;
  certificadoDigital?: {
    id: string;
    nome: string;
    referencia: string;
    existeSenha: boolean;
  };
}

export interface ParametrosCobrancaTaxasResponse {
  taxaJuros: number;
  taxaMulta: number;
  proRataDia: boolean;
}

export interface ParametrosCobrancaTransferenciaResponse {
  categoriaTransferenciaRecebimentoId: string;
  categoriaTransferenciaEnvioId: string;
}

export interface ParametrosCobrancaJurosItem {
  diasInadimplencia: number;
  valor: number;
}

export type ParametrosCobrancaJurosResponse = ParametrosCobrancaJurosItem[];

export interface CategoriaItem {
  id: string;
  breadcrumb: string;
  nome: string;
  categoriaFinanceiraPaiId: string;
  ordem: number | string;
}

export interface CategoriaFinanceiraItem {
  createdAt: string;
  updatedAt: string;
  deletedAt: string;
  tenantId: string;
  categoriaFinanceiraPaiId: null | string;
  id: string;
  nome: string;
  ordem: number | null;
  breadcrumb: string;
  readOnly: boolean;
  operacao: number;
  items: CategoriaFinanceiraItem[] | null;
  codigoIntegracao?: string | null;
  podeClassificarConta?: boolean | null;
  centroDeCustoId?: string | null;
  centroDeCusto?: {
    id: string;
    nome: string;
  };
  ativo?: boolean | null;
}
